import React from 'react';
import { BiEdit } from 'react-icons/bi';
import { MdDelete } from 'react-icons/md';
import SectionCreateOrUpdateInputTemplate from './SectionCreateOrUpdateInputTemplate';
import { useDispatch, useSelector } from 'react-redux';
import { deleteSection, updateSection } from '../../../../services/operations/courseApi';

const UpdateSection = ({
    section,
    moduleType,
    register,
    getValues,
    setValue,
    errors,
    setBgBlurModal,
    setConfirmationModal,
}) => {
    const dispatch = useDispatch();
    const { courseEntireData } = useSelector(state => state.viewCourse)
    const deleteSectionHandler = (section) => {
        try {
            dispatch(deleteSection(section._id, courseEntireData._id, dispatch));
        } catch (error) {
            console.log(error.message);
        }
    }
    const updateSectionNameHandler = () => {
        try {
            dispatch(updateSection(section._id, getValues('sectionName'), dispatch));
        } catch (error) {
            console.log(error.message)
        }
    }

    return (
        <div className='flex items-center gap-x-2'>
            <button
                type='button'
                className='hover:text-caribbeangreen-500 transition-colors duration-300 text-lg'
                onClick={() => setBgBlurModal(
                    <SectionCreateOrUpdateInputTemplate
                        moduleType={moduleType}
                        register={register}
                        getValues={getValues}
                        setValue={setValue}
                        section={section}
                        errors={errors}
                        updateSectionNameHandler={updateSectionNameHandler}
                        setBgBlurModal={setBgBlurModal}
                    />
                )}
            >
                <BiEdit />
            </button>
            <button
                type='button'
                className='hover:text-pink-500 transition-colors duration-300 text-lg'
                onClick={() => setConfirmationModal(
                    {
                        text1: 'Delete Section Confirmation',
                        text2: 'Are You Sure You Want to Delete This Section?',
                        closeModal: () => setConfirmationModal(null),
                        btn1Text: 'Delete',
                        btn2Text: 'Cancel',
                        btn1Handler: () => deleteSectionHandler(section),
                        btn2Handler: () => setConfirmationModal(null),
                    }
                )}
            >
                <MdDelete />
            </button>
        </div>
    )
}

export default UpdateSection;